import CreativeView from "./CreativeView";

export default CreativeView;
